// extracted by mini-css-extract-plugin
module.exports = {"link":"HeaderLogo_link__1hWkx","separator":"HeaderLogo_separator__3iHry","component":"HeaderLogo_component__xyhWz","title":"HeaderLogo_title__3Ytmc"};